import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'
import Button from 'parkdepot-shared/components/Buttons/Button'
import { BUTTON_SIZE } from 'parkdepot-shared/components/Buttons/types'
import { Container, WemolonIcon, TitleContainer, Title, Subtitle } from './NotFound.style'
import { homeRoute } from '../Home/route.const'

type StateType = {
    title?: string
    errorMessage?: string
}

const LotNotFound = () => {
    const { push } = useHistory()
    const { state } = useLocation<StateType>()
    const { t } = useTranslation()

    const onHomeClick = () => {
        push(homeRoute())
    }

    return (
        <Container>
            <TitleContainer>
                <WemolonIcon className="wemolo-wemolon" aria-hidden="true" />
                <Title>{state?.title || t('404.title')}</Title>
                {state?.errorMessage && <Subtitle>{state.errorMessage}</Subtitle>}
            </TitleContainer>

            <Button
                id="home-button"
                onClick={onHomeClick}
                $size={BUTTON_SIZE.medium}
                overrides={{
                    BaseButton: {
                        style: {
                            width: '100%'
                        }
                    }
                }}
            >
                {t('404.back')}
            </Button>
        </Container>
    )
}

export default LotNotFound
